var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmt24Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 27,
    viewBox: "0 0 72 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1395_4455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 12.9359H66.5139V14.0641H72V12.9359Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1955 0.5H59.1235V6.27335H60.1955V0.5Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1955 20.7134H59.1235V26.4867H60.1955V20.7134Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7046 24.0048L70.4613 23.2085L69.5659 22.2927L61.2044 13.4934L69.5659 4.70724L68.8092 3.91092L60.4477 12.7103L59.691 13.4934L60.4477 14.2897L68.5444 22.8104L69.7046 24.0048Z",
    fill: "url(#paint0_linear_1395_4455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.123 4.06274L62.0708 6.73587L62.4903 6.91872L63.5424 4.24559L63.123 4.06274Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4921 20.0823L62.0727 20.2652L63.1254 22.938L63.5448 22.7551L62.4921 20.0823Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88439 6.92368C3.93484 6.60515 4.01051 6.33971 4.09879 6.1539C4.18707 5.96809 4.30058 5.79555 4.42669 5.63629C4.62848 5.39739 4.88071 5.19831 5.18339 5.05231C5.48607 4.90632 5.8392 4.82669 6.23016 4.82669C6.97425 4.82669 7.55439 5.0125 7.97057 5.38412C8.38676 5.75573 8.68944 6.32643 8.85339 7.06967L8.90384 7.30857H12.6495L12.5991 6.95022C12.4855 6.20698 12.2838 5.49029 11.9685 4.81342C11.6658 4.13654 11.237 3.51275 10.7199 2.99514C10.2028 2.46426 9.55964 2.03955 8.81555 1.72102C8.07147 1.41577 7.20126 1.2565 6.23016 1.2565C5.2969 1.2565 4.43931 1.42904 3.69522 1.76084C2.95113 2.09264 2.2701 2.58371 1.67735 3.2075C1.24855 3.65875 0.90804 4.14981 0.68103 4.66742C0.45402 5.17176 0.290068 5.72919 0.189175 6.31316C0.100893 6.88386 0.037835 7.50765 0.0252233 8.14471C0.0126117 8.78177 0 9.47192 0 10.2019C0 10.9318 0.0126117 11.622 0.0252233 12.2591C0.037835 12.9094 0.100893 13.5199 0.189175 14.0906C0.290068 14.6746 0.45402 15.232 0.68103 15.7363C0.90804 16.2539 1.24855 16.745 1.67735 17.1963C2.2701 17.8201 2.96374 18.3111 3.70783 18.6429C4.45192 18.9747 5.30951 19.1473 6.23016 19.1473C7.12559 19.1473 7.97057 19.0013 8.76511 18.696C9.57225 18.3908 10.3163 17.8599 10.9974 17.1166C11.5901 16.4663 12.0063 15.7098 12.2585 14.8604C12.4982 14.0375 12.6243 12.9757 12.6243 11.7282V8.94103H5.94009V12.3254H8.91645V12.6705C8.91645 13.0819 8.866 13.4668 8.76511 13.8119C8.66421 14.1437 8.50026 14.4622 8.27325 14.7409C8.04624 15.0064 7.75617 15.2187 7.42827 15.3647C7.08776 15.5107 6.68418 15.5903 6.24277 15.5903C5.85181 15.5903 5.49869 15.524 5.19601 15.378C4.89333 15.232 4.64109 15.0462 4.43931 14.8073C4.31319 14.6613 4.19968 14.4888 4.1114 14.2897C4.02312 14.1039 3.94745 13.8384 3.897 13.5199C3.83395 13.1881 3.79611 12.7501 3.77089 12.2192C3.74566 11.6884 3.73305 11.0115 3.73305 10.2019C3.73305 9.39228 3.74566 8.72868 3.77089 8.1978C3.7835 7.68019 3.83395 7.25548 3.88439 6.92368Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7929 10.1886L17.7572 1.4025H14.1755V19.0145H17.9085V10.0692L20.5444 15.5505H23.0415L25.6521 10.0824V19.0145H29.3851V1.4025H25.8034L21.7929 10.1886Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6653 1.4025H30.495V4.97269H34.7199V19.0145H38.453V4.97269H42.6653V1.4025Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3784 12.6838C48.5171 12.498 48.6432 12.2989 48.7315 12.0998C48.8198 11.9007 48.8955 11.7016 48.9459 11.4893C48.9964 11.2769 49.0216 11.038 49.0216 10.7726C49.0216 10.2815 48.9459 9.83029 48.782 9.43212C48.6306 9.03396 48.4036 8.70216 48.1262 8.42345C47.8487 8.14473 47.5082 7.93238 47.1172 7.78639C46.7263 7.64039 46.2975 7.56076 45.8308 7.56076C45.3768 7.56076 44.9606 7.62712 44.5696 7.77311C44.1787 7.91911 43.8382 8.13146 43.5481 8.41017C43.258 8.68889 43.031 9.03396 42.8671 9.43212C42.7031 9.83029 42.6274 10.2815 42.6274 10.7859H44.5444C44.5444 10.5204 44.5823 10.2948 44.6579 10.109C44.7336 9.92319 44.8345 9.7772 44.948 9.67102C45.0741 9.56484 45.2128 9.48521 45.3642 9.43212C45.5155 9.37904 45.6669 9.36576 45.8308 9.36576C46.247 9.36576 46.5623 9.49848 46.7767 9.75065C46.9911 10.0028 47.1046 10.3346 47.1046 10.7593C47.1046 11.0248 47.0668 11.2504 46.9785 11.4495C46.8902 11.6486 46.7515 11.8609 46.5623 12.0998L42.6274 16.891V18.7093H49.0216V16.891H44.9606L47.8991 13.3076C48.0757 13.0819 48.227 12.8829 48.3784 12.6838Z",
    fill: "url(#paint1_linear_1395_4455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3741 15.2187V13.1616H54.5202V15.2187H52.3258L55.9327 7.64038H53.8266L50.2322 15.2187V17.1299H54.5202V18.7093H56.3741V17.1299H57.3326V15.2187H56.3741Z",
    fill: "url(#paint2_linear_1395_4455)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_4455",
    x1: 60.3492,
    y1: 3.91092,
    x2: 75.8819,
    y2: 13.8355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1395_4455",
    x1: 43.0182,
    y1: 7.56076,
    x2: 51.8678,
    y2: 13.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1395_4455",
    x1: 50.6662,
    y1: 7.64038,
    x2: 59.7659,
    y2: 14.5986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEAE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1395_4455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 26,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmt24Logo);
export default __webpack_public_path__ + "static/media/gmt24Logo.d78ddeee65bee2a3ffe7e17052143237.svg";
export { ForwardRef as ReactComponent };